import React from 'react';
import PropTypes from 'prop-types';
import { EditorContext } from '../../../hoc/Editor';
import { RouteContext } from '../../../hoc/Route';

const withRequirement = WrappedComponent => props => {
  const { requirements, editMode } = React.useContext(EditorContext);
  const { page } = React.useContext(RouteContext);
  // eslint-disable-next-line
  const { label } = props;

  if (
    requirements &&
    Object.keys(requirements).includes(page) &&
    label &&
    page &&
    requirements[page][label] &&
    editMode
  ) {
    return (
      <div className="wrapperContainer">
        <span className="requirementTag">*</span>
        <WrappedComponent {...props} />
      </div>
    );
  }

  return <WrappedComponent {...props} />;
};

withRequirement.propTypes = {
  label: PropTypes.string.isRequired,
};

export default withRequirement;
